import { useCallback } from 'react';
import { useCreatePriceQuoteFromOrderGuideMutation } from '@/experiences/sales-portal/domain/order-guides/screens/order-guides-list/blocs/documents/create-price-quote-from-order-guide.generated';

interface CreatePriceQuoteInput {
  chatUUID: string;
  variantPackUUIDs: string[];
}

interface UseCreatePriceQuoteFromOrderGuideMutatorOptions {
  onError?: () => void;
}

interface UseCreatePriceQuoteFromOrderGuideMutatorResult {
  createPriceQuote: (input: CreatePriceQuoteInput) => Promise<string | null>;
  loading: boolean;
}

export const useCreatePriceQuoteFromOrderGuideMutator = ({
  onError,
}: UseCreatePriceQuoteFromOrderGuideMutatorOptions = {}): UseCreatePriceQuoteFromOrderGuideMutatorResult => {
  const [mutate, { loading }] = useCreatePriceQuoteFromOrderGuideMutation();

  const createPriceQuote = useCallback(
    async ({ chatUUID, variantPackUUIDs }: CreatePriceQuoteInput) => {
      try {
        const { data } = await mutate({
          variables: {
            chat_id: chatUUID,
            variant_pack_ids: variantPackUUIDs,
          },
        });
        const priceQuoteId =
          data?.createPriceQuoteFromOrderGuide.price_quote_id;
        if (!priceQuoteId) {
          onError?.();
          return null;
        }
        return priceQuoteId;
      } catch {
        onError?.();
        return null;
      }
    },
    [mutate, onError],
  );

  return {
    createPriceQuote,
    loading,
  };
};
